"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _system = require("@mui/system");
var _Tile = _interopRequireDefault(require("./Tile"));
var _concatTokens = _interopRequireDefault(require("../../services/concatTokens"));
var _StepTile = _interopRequireDefault(require("./StepTile"));
/**
 *
 * @param {*} param0
 */
var Tiles = function Tiles(_ref) {
  var tiles = _ref.tiles,
    stepped = _ref.stepped,
    children = _ref.children,
    customStyle = _ref.customStyle,
    classes = _ref.classes,
    id = _ref.id,
    testid = _ref.testid;
  var Container = (0, _system.styled)('div')({
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 auto'
  });
  return /*#__PURE__*/_react["default"].createElement(Container, {
    id: id || testid,
    style: customStyle
  }, children, tiles.map(function (tile) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      key: (0, _concatTokens["default"])(tile.title, tile.description),
      to: tile.link || '',
      onClick: !tile.link ? function (e) {
        e.preventDefault();
        if (tile.disabled) {
          return;
        }
        tile.onClick();
      } : null,
      style: {
        width: '50%',
        padding: "5px 8px",
        textDecoration: 'none',
        zIndex: 2
      }
    }, stepped ? /*#__PURE__*/_react["default"].createElement(_StepTile["default"], {
      id: tile.id || tile.testid,
      title: tile.title,
      description: tile.description,
      step: tile.step,
      disabled: tile.disabled,
      tooltip: tile.tooltip,
      completed: tile.completed,
      icon: tile.icon
    }) : /*#__PURE__*/_react["default"].createElement(_Tile["default"], {
      id: tile.id || tile.testid,
      title: tile.title,
      description: tile.description,
      icon: tile.icon,
      isSelected: tile.isSelected,
      step: tile.step,
      disabled: tile.disabled,
      tooltip: tile.tooltip,
      subtitle: tile.subtitle
    }));
  }));
};
var _default = exports["default"] = Tiles;